/** Read a QR code from a photo or screenshot without uploading the image. */
export async function decodeQrImage(file: File): Promise<string | null> {
  if (file.size > 12 * 1024 * 1024) throw new Error("Choose an image smaller than 12 MB.");
  if (file.type && !file.type.startsWith("image/")) throw new Error("Choose an image file.");

  const url = URL.createObjectURL(file);
  try {
    const image = new Image();
    image.src = url;
    await image.decode();

    const canvas = document.createElement("canvas");
    const scale = Math.min(1, 2400 / Math.max(image.naturalWidth, image.naturalHeight));
    canvas.width = Math.round(image.naturalWidth * scale);
    canvas.height = Math.round(image.naturalHeight * scale);
    const context = canvas.getContext("2d", { willReadFrequently: true });
    if (!context || !canvas.width || !canvas.height) throw new Error("Could not read this image.");
    context.drawImage(image, 0, 0, canvas.width, canvas.height);

    const { default: jsQR } = await import("jsqr");
    const pixels = context.getImageData(0, 0, canvas.width, canvas.height);
    return jsQR(pixels.data, canvas.width, canvas.height, { inversionAttempts: "attemptBoth" })?.data.trim() ?? null;
  } finally {
    URL.revokeObjectURL(url);
  }
}
